import React from 'react'
import { Row, Col, Form } from 'react-bootstrap'
import { get } from 'lodash'

const TextField = ({
    type,
    placeholder,
    value,
    label,
    required,
    onChange = () => {},
    keyField = ''
}) => (
    <Row style={{ paddingBottom: '20px' }}><Col>
        <Form.Label>{label}</Form.Label>
        <Form.Control
            type={type || 'text'}
            placeholder={placeholder}
            value={get(value, keyField, '') || ''}
            onChange={e => onChange({ ...value, [keyField]: e.target.value})}
        />
    </Col></Row>
)

export default TextField